import { DataMapType } from "./type";
export const PresetDataMap = {
  [DataMapType.urlStringToObject]: {
    convert(s) {
      if (!s) {
        return {};
      }
      const protocol = [
        "http://",
        "https://"
      ].find((i) => s.startsWith(i));
      if (protocol) {
        return {
          protocol,
          domain: s.replace(protocol, "")
        };
      }
      return {
        domain: s
      };
    },
    revert(t) {
      if (!t) {
        return;
      }
      const { protocol, domain } = t;
      return `${protocol !== null && protocol !== void 0 ? protocol : ""}${domain !== null && domain !== void 0 ? domain : ""}`;
    }
  },
  [DataMapType.dateStringFormat]: {
    convert(s) {
      if (!s || s.length !== 8) {
        return;
      }
      return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
    },
    revert(t) {
      if (!t) {
        return;
      }
      return t.split("-").join("");
    }
  }
};
